/**
 * @name pathLocation
 * @description
 * Function to work with the location path of the page
 **/
export default class PathLocation {

    constructor() {}

    /**
     * @name getPath
     * @description
     * Get path
     * @return
     * { string } Pathname
     */
    getPath() {
        return window.location.pathname;
    }

    /**
     * @name getSection
     * @description
     * Get section of navigation
     * @return
     * { string } Section URL Slug
     */
    getSection() {
        let path = window.location.pathname.split('/');
        return (path[1] === 'pages') ? path[2] : path[1];
    }

    /**
     * @name getCollection
     * @description
     * Get collection of navigation
     * @return
     * { string } Section URL Slug
     */
    getCollection() {
        let path = window.location.pathname.split('/');
        return path[1] === 'collections' ? path[2] : null;
    }

    /**
     * @name getEnvironment
     * @description
     * Get environment of platform
     * @return
     * { string } Enviroment name
     */
    getEnvironment() {
        let path = window.location.host.split('.');
        return (path[0] === 'www') ? 'prod' : path[0];
    }

    /**
     * @name getEnvironment
     * @description
     * Get environment of platform
     * @return
     * { string } Enviroment name
     */
    getParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        let results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    /**
     * @name redirectTo
     * @description
     * Set a redirect to another url
     */
    redirectTo(loc) {
        window.location = loc;
    }

}